import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import TrainingEvaluation from './components/TrainingEvaluation';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2A78B7',
      light: '#3498DB',
      dark: '#2C3E50',
    },
    secondary: {
      main: '#717171',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    success: {
      main: '#39B54A',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TrainingEvaluation />
    </ThemeProvider>
  );
}

export default App;
